export const bookingRegistrationNotificationTemplate = `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office">
  <head>
    <meta charset="UTF-8" />
    <meta content="width=device-width, initial-scale=1" name="viewport" />
    <meta name="x-apple-disable-message-reformatting" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta content="telephone=no" name="format-detection" />
  </head>
  <body
    align="center"
    style="background: white; width: 100%; font-family: verdana, geneva, sans-serif; margin: 0; padding: 0"
  >
    <div style="background: white">
      <div style="background-color: #f7f7f7; height: 34px">
        <div style="color: #cccccc; padding: 10px; margin: 0px; font-size: 12px">
          Du hast eine neue Reservierung in deinem Dashboard.
        </div>
      </div>
      <div align="center" style="padding-top: 20px">
        <img class="adapt-img" src="{{tenantLogo}}" width="180" />
      </div>
      <div style="margin: 0; padding-top: 20px; padding-bottom: 40px; max-width: 600px; margin: auto">
        <h2 style="margin: 0; font-size: 24px; color: #333333; font-style: normal; font-weight: normal">
          Hallo {{name}},
        </h2>
        <p
          style="
            margin: 0;
            font-size: 16px;
            font-family: verdana, geneva, sans-serif;
            line-height: 24px;
            color: #333333;
            padding-top: 16px;
          "
        >
          du hast eine neue Reservierung.
        </p>
        <p
          style="
            margin: 0;
            font-size: 16px;
            font-family: verdana, geneva, sans-serif;
            line-height: 24px;
            color: #333333;
            padding-top: 16px;
          "
        >
          <a href="http://my-v2.xeetr.de/dashboard">Gehe zum Dashboard</a>
        </p>
      </div>
      <div style="margin: 0; background-color: #f7f7f7; width: 100%; padding-top: 20px; padding-bottom: 20px">
        <h2
          style="
            margin: 0;
            line-height: 36px;
            font-family: arial, 'helvetica neue', helvetica, sans-serif;
            font-size: 24px;
            color: #333333;
            padding-top: 10px;
            font-style: normal;
            font-weight: normal;
          "
        >
          Reservierungsdetails
        </h2>
        <div style="padding-top: 10px; padding-bottom: 10px">
          <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333; padding-top: 10px">
            <strong>Wer<br /></strong>
          </p>
          <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">{{customerName}}</p>
        </div>
        {{tenantSpecificPart}}
        <div style="margin: 0; padding-top: 10px; padding-bottom: 10px">
          <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333; padding-top: 10px">
            <strong>Wann</strong>
          </p>
          <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">{{booking}}</p>
        </div>
      </div>
      <div style="padding-top: 20px; padding-bottom: 20px; max-width: 600px; margin: auto">
        <p
          style="margin: 0; padding-top: 10px; padding-bottom: 10px; font-size: 14px; line-height: 21px; color: #333333"
        >
          Du erhälst diese E-Mail, da du in deinen Einstellungen dies aktivierst hast.
        </p>
        {{footer}}
      </div>
    </div>
  </body>
</html>
`
